(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.searchRow = this.querySelector('.header__sw-search');
      this.searchShown = true;
      this.searchScrollY = window.scrollY || 0;
      this.searchTravel = 0;
      this.searchFrame = 0;
      this.restingTopCache = null;
      this.onSearchScroll = this.onSearchScroll.bind(this);
      this.runSearchScroll = this.runSearchScroll.bind(this);
      this.searchMediaQuery = window.matchMedia('(max-width: 989px)');

      this.setHeaderHeight();
      this.watchStuck();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      this.searchMediaQuery.addEventListener('change', this.setHeaderHeight);
      window.addEventListener('scroll', this.onSearchScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);
      if (this.searchRow) this.resizeObserver.observe(this.searchRow);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      this.restingTopCache = null;
      this.setRootVar('--header-height', `${this.header.offsetHeight}px`);
      this.syncSearchRow();
      this.syncStickyOffset();
      if (this.searchMediaQuery.matches) this.header.classList.remove('is-stuck');
    }

    /* Stuck height only: the ticker and announcement are siblings above this section, so they
       scroll away. The mobile search row is outside the pinned bar and is added while it is visible. */
    syncStickyOffset() {
      let extra = 0;
      if (this.searchMediaQuery.matches && this.searchShown && this.searchRow) {
        extra = this.searchRow.offsetHeight;
      }
      this.setRootVar('--sw-sticky-offset', `${this.header.offsetHeight + extra}px`);
    }

    /* Custom properties on :root restyle the whole document, so only write real changes. */
    setRootVar(name, value) {
      this.rootVars = this.rootVars || {};
      if (this.rootVars[name] === value) return;
      this.rootVars[name] = value;
      document.documentElement.style.setProperty(name, value);
    }

    watchStuck() {
      if (!this.headerIsAlwaysSticky || this.stuckObserver) return;
      const sentinel = document.createElement('div');
      sentinel.className = 'sw-header-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.textContent = '\u00a0';
      this.header.parentNode.insertBefore(sentinel, this.header);
      this.stuckSentinel = sentinel;
      this.stuckObserver = new IntersectionObserver((entries) => {
        if (this.searchMediaQuery.matches) {
          this.header.classList.remove('is-stuck');
          return;
        }
        this.header.classList.toggle('is-stuck', !entries[0].isIntersecting);
      });
      this.stuckObserver.observe(sentinel);
    }

    /* The search row is not part of the pinned bar. Its visible height is added to
       --sw-sticky-offset so the brand bar and the other pinned rows sit below it. */
    syncSearchRow() {
      const row = this.searchRow;
      if (!row) return;
      if (!this.searchMediaQuery.matches) {
        row.classList.remove('is-hidden', 'is-animating');
        this.setRootVar('--sw-msearch-y', '0px');
        this.setRootVar('--sw-msearch-visible', '0px');
        this.searchShown = true;
        return;
      }
      this.searchHeight = row.offsetHeight;
      this.applySearch(this.searchShown !== false, false, true);
    }

    applySearch(shown, animate, force = false) {
      const row = this.searchRow;
      if (!row) return;
      if (!force && shown === this.searchShown) return;
      const height = this.searchHeight || row.offsetHeight;
      this.searchShown = shown;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.classList.toggle('is-animating', Boolean(animate) && !reduce);
      row.classList.toggle('is-hidden', !shown);
      this.setRootVar('--sw-msearch-h', `${height}px`);
      this.setRootVar('--sw-msearch-y', shown ? '0px' : `${-height}px`);
      this.setRootVar('--sw-msearch-visible', shown ? `${height}px` : '0px');
      this.syncStickyOffset();
    }

    /* offsetTop follows a stuck sticky element, so measure the layout position from the in-flow siblings above it. */
    restingTop() {
      if (this.restingTopCache !== null) return this.restingTopCache;
      let top = 0;
      let sibling = this.header.previousElementSibling;
      while (sibling) {
        const position = getComputedStyle(sibling).position;
        if (position !== 'absolute' && position !== 'fixed' && getComputedStyle(sibling).display !== 'none') {
          top += sibling.offsetHeight;
        }
        sibling = sibling.previousElementSibling;
      }
      this.restingTopCache = top;
      return top;
    }

    /* One measurement per frame, however many scroll events the browser sends. */
    onSearchScroll() {
      if (this.searchFrame || !this.searchRow || !this.searchMediaQuery.matches) return;
      this.searchFrame = requestAnimationFrame(this.runSearchScroll);
    }

    /* Direction needs a sustained run (down 24px to hide, up 48px to show), so thumb wobble,
       momentum jitter and iOS rubber-banding cannot flip the row in and out. */
    runSearchScroll() {
      this.searchFrame = 0;
      const row = this.searchRow;
      if (!row || !this.searchMediaQuery.matches) return;

      const rawY = window.scrollY || 0;
      const maxY = document.documentElement.scrollHeight - window.innerHeight;
      const locked =
        document.documentElement.classList.contains('sw-modal-open') ||
        document.body.classList.contains('overflow-hidden');
      if (locked || rawY < 0 || rawY > maxY + 1) {
        this.searchScrollY = Math.min(Math.max(rawY, 0), Math.max(maxY, 0));
        this.searchTravel = 0;
        return;
      }

      if (row.querySelector('details[open]')) {
        this.applySearch(true, false);
        this.searchScrollY = rawY;
        this.searchTravel = 0;
        return;
      }

      const y = rawY;
      const delta = y - this.searchScrollY;
      this.searchScrollY = y;
      const resting = this.restingTop();

      if (y <= resting + 4) {
        this.searchTravel = 0;
        this.applySearch(true, delta < 0);
        return;
      }

      if (delta === 0) return;
      if (Math.sign(delta) !== Math.sign(this.searchTravel)) this.searchTravel = 0;
      this.searchTravel += delta;

      const marginGone = y > resting + (this.searchHeight || row.offsetHeight);
      if (this.searchTravel > 24 && marginGone) this.applySearch(false, true);
      else if (this.searchTravel < -48) this.applySearch(true, true);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.searchFrame);
      this.resizeObserver?.disconnect();
      this.stuckObserver?.disconnect();
      this.stuckSentinel?.remove();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.searchMediaQuery?.removeEventListener('change', this.setHeaderHeight);
      window.removeEventListener('scroll', this.onSearchScroll);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.headerIsAlwaysSticky) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (window.SwNav) window.SwNav.close();
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /* Mobile side menu: the scrim (the <details> element itself), the close button and the
     concierge link all close the whole menu and release the scroll lock. Runs in the capture
     phase because Dawn binds every drawer button to "close submenu", which leaves the page locked. */
  const closeSwMenu = (event) => {
    const container = document.getElementById('Details-menu-drawer-container');
    if (!container || !container.open) return;
    const drawer = container.closest('header-drawer');
    const summary = container.querySelector('summary');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, summary);
    } else {
      container.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  document.addEventListener(
    'click',
    (event) => {
      const container = document.getElementById('Details-menu-drawer-container');
      if (!container || !container.open) return;
      if (event.target === container || event.target.closest('[data-sw-menu-close]')) {
        event.stopPropagation();
        event.preventDefault();
        closeSwMenu(event);
      } else if (event.target.closest('#menu-drawer .trigger-concierge-drawer')) {
        closeSwMenu(event);
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
